import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";

const AboutUsSwiperSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);

  const years = ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026"];

  const content = [
    {
      title: "Journey Started",
      description: "The journey of Infinitive Host started in 2017 with a clear mission—to work on customers’ pain points by offering a trusted and performance-centered web hosting provider. Our main offerings in 2017 were Dedicated Servers, VPS, Cloud Servers, and Email Hosting.",
    },
    {
      title: "Worldwide Expansion",
      description: "We collaborated with the well-known Akamai to offer cloud-based services at the global level. 2018 is also seen as the addition of our lag-free and buffer-free streaming servers, allowing Video-on-Demand (VOD).",
    },
    {
      title: "Team and Support Growth",
      description: "With reliable year-on-year growth, we expanded into a worldwide team, offering web hosting and infrastructure solutions with 24/7 expert support.",
    },
    {
      title: "Scaling Infrastructure",
      description: "A huge milestone-our client base crossed 3,000+ clients, backed by 500+ servers deployed internationally, fortifying our global infrastructure.",
    },
    {
      title: "Continuity in Services",
      description: "Despite all the ongoing challenges of the COVID era, we guarantee continuous services globally. We introduced our own streaming solutions, which help to offer buffer-free virtual collaboration.",
    },
    {
      title: "Expansion of Business",
      description: "To expand our market presence, we added dedicated development and digital marketing solutions, helping a large base of clients to grow both digitally and technically.",
    },
    {
      title: "Enterprise-Level Services",
      description: "We partnered with Microsoft to provide Office 365 email services, including enterprise-level communication services, to our portfolio.",
    },
    {
      title: "Global Reach",
      description: "Our business grows beyond expectations—serving more than 6,000 clients along with 700+ servers globally, providing hosting services across different countries like the USA, Europe, and Asia.",
    },
    {
      title: "New Venture: GPU4HOST ",
      description: "Replying to the increasing demand for high-performance computing (HPC) or ML, we added GPU Servers to our list and also launched our new venture, which is GPU4HOST.",
    },
    {
      title: "Future-Ready Solutions",
      description: "With day-by-day growth in AI, we expanded our GPU solutions portfolio, earning appreciation from clients globally for dedicated performance, speed, and expert support.",
    },
  ];

  return (
    <section className="story-timeline-section position-relative z-1 bg-dark pt-120 pb-60">
      <div className="pb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <h2 className="mb-4 text-center text-white">
                Our history
              </h2>
              <p className="mb-0 text-white text-center mx-auto max-text-60 text-opacity-75">
                Our global data centers mean you can host precisely where you need.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="swiper-wrapper">
          <Swiper
            modules={[Navigation, Thumbs, FreeMode, Autoplay]}
            onSwiper={setThumbsSwiper}
            slidesPerView={4}
            freeMode
            watchSlidesProgress
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
            0: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: 5,
            },
          }}
            className="timeline-slider-nav"
          >
            {years.map((year) => (
              <SwiperSlide key={year}>
                <div className="story-timeline text-center">
                  <div className="story-timeline__time">{year}</div>
                  <div className="story-timeline__dot"></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button ref={prevRef} className="timeline-slider-nav__prev">
            <i className="fa-solid fa-angle-left"></i>
          </button>
          <button ref={nextRef} className="timeline-slider-nav__next">
            <i className="fa-solid fa-angle-right"></i>
          </button>
        </div>

        <Swiper
          modules={[Thumbs]}
          thumbs={{ swiper: thumbsSwiper }}
          slidesPerView={1}
          className="timeline-slider-content mt-4"
        >
          {content.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="p-4 p-md-12 p-xl-15 text-center">
                <h5 className="mb-4 text-white">{item.title}</h5>
                <p className="mb-0 text-white max-text-60 text-opacity-75 m-auto">
                  {item.description}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default AboutUsSwiperSlider;
